module.exports = __webpack_public_path__ + "img/modelMarket1.030a23fe.png";